/**
 * Construye el payload de `back.abonos.bloquear.asientos` para butacas de la
 * vista REGIÓN, serializando la selección a objetos `{ row, seat, region_id,
 * zona_nombre }`.
 *
 * Función PURA: no lee store global. `listaId` se inyecta para mantener la
 * serialización desacoplada (ver Hallazgo): así es testeable sin montar el
 * componente y reutilizable por cualquier consumer de abonos.
 *
 * @param {import('vue').Ref<Array>} asientos Ref con los { row, seat,
 *   region_id, zona_nombre, bloqueada } seleccionados.
 * @param {Object} ctx Context de la acción: { concepto, etiqueta, n_butacas,
 *   zona_id }.
 * @param {string|number} listaId Id de la lista de abonados.
 * @returns {Object} Payload para back.abonos.bloquear.asientos.
 */
export function buildRegionBlockerPayload(asientos, ctx, listaId) {
    const params = {
        filters: {
            lista_id: listaId
        },
        asientos: asientos.value.map(({ row, seat, region_id, zona_nombre }) => ({
            row,
            seat,
            region_id,
            zona_nombre
        })),
        concepto: ctx.concepto,
        lista_id: listaId,
        n_butacas: ctx.n_butacas,
        zona_id: ctx.zona_id
    }

    if (ctx.etiqueta) {
        params.etiqueta_bloqueo_id = ctx.etiqueta.id
    }

    return params
}
